export default {
  computed: {
    hasAssetPath() {
      return !!this.config && !!this.config.base_asset_url;
    }
  },

  methods: {
    assetPath(img) {
      if (!this.config.base_asset_url) {
        return;
      }

      if (this.config.base_asset_url.endsWith('/')) {
        return `${this.config.base_asset_url}${img}`;
      } else {
        return `${this.config.base_asset_url}/${img}`;
      }
    },

    getAssetUrl(path, localPath = '') {
      if (!path) {
        return '';
      }

      return this.hasAssetPath
        ? this.assetPath(path)
        : localPath;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/assetHandler.js